export const isEmbed = (url) => url.includes("?embed")